import { defineInlineEdit } from "../../../../../components/MobileList/inlineEdit";

/**
 * views/jomla/monthlyTarget/from PUTs `{year, month, j_item_id, user_id, target}`,
 * deriving year/month from a month picker. The row carries them already — the
 * slice's setById just spreads it — so no detail fetch is needed and the period
 * rides along unchanged.
 *
 * `achieved` / `is_achieved` are computed from actual sales and are not in the
 * form; the item and rep are picked together at creation and stay in the dialog.
 */
export default defineInlineEdit({
  api: "jMonthlyTarget",
  permission: "j_monthly_target_edit",
  hydrate: false,
  toPayload: (source) => ({
    year: source.year,
    month: source.month,
    j_item_id: source.j_item_id,
    user_id: source.user_id,
    target: source.target,
  }),
  fields: {
    target: {
      label: "الهدف",
      type: "number",
      required: true,
      toPatch: (value) => ({ target: Number(value) }),
    },
  },
});
